
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

import {getAreaId, getOperationList, getSTBRemoteIds} from "../../../api/kookong.js";

import {windVane} from "../../../utils/tmallGenius";

export default {
name: "brandList",
components: {
Group,
Cell,
CellFormPreview,
CellBox,
Badge,
InlineLoading
},

data() {
return {
keyword: "",
loading: true,
list: [
{
cname: "创维",
ename: "tcl",
brandeviceGeneralType: 1
},
{
cname: "创维",
ename: "123",
brandeviceGeneralType: 2
},
{
cname: "创维",
ename: "123",
brandeviceGeneralType: 3
}
],
filteredList: [],
urlData: null,
data: {
province: "",
city: "",
},
cityId: undefined
};
},
beforeRouteEnter(to, from, next) {
windVane.setNavTitle("选择机顶盒品牌");
next();
},
created() {
this.getPCA(() => {
const params = {
province: this.data.province,
city: this.data.city,
};
getAreaId(params)
.then(res => {
console.log(res);
this.cityId = res.data.cityId;
const param = {
cityId: this.cityId
};
return getOperationList(param).then(res => {
this.loading = false;
return res.data;
});
})
.then(data => {
this.list = data;
this.filteredList = this.list;
this.loading = false;
})
.catch(e => {
alert(e);
});
});
},
methods: {
/* @name 根据经纬度获取省市区
*/
getPCA(cb) {




windVane
.getLocation()
.then(result => {
this.data.province = result.province;
this.data.city = result.city;
cb && cb();
})
.catch(e => {
console.error(JSON.stringify(e));
alert("请授权定位权限");
});
},
async gotoPanel(item) {
const params = {
spId: item.spId,
cityId: this.cityId
};
const res = await getSTBRemoteIds(params);

const router = {
0: "/device/tvbox",
1: "/device/tvbox/iptv_list"
};
this.$router.push({
path: router[item.type],
query: {
bid: item.brandId,
kookongDeviceType: this.$route.query.kookongDeviceType,
uid: this.$route.query.uid,
deviceId: this.$route.query.deviceId,
rids: res.data.join(","),
deviceType: this.$route.query.deviceType,
areaId: this.cityId, // 区域id实际是城市id（后台接口规定）
aligenieZone: this.$route.query.aligenieZone,
spType: item.type, // 判断是ipTV类型
spId: item.spId,
}
});
},
filterBrand() {
const reg = new RegExp(this.keyword, "gi");
const list = this.list.filter(item => {
return reg.test(item.spName);
});

this.filteredList = list;
}
}
};



// WEBPACK FOOTER //
// ./src/pages/device/tvBox/BrandList.vue